(function(){
/* LOCAL OPTIONAL THEME SAFEGUARD; not installed. Does not grant consent,
 * set banner choices, emit analytics, or load OpenAI. Configure endpoint only.
 * It can retry withdrawal when a privacy-gated custom pixel no longer runs.
 */
function installConsentWithdrawalObserver({Shopify,document,storage,endpoint,fetcher=fetch,enabled=false}) {
  if(!enabled || !Shopify?.loadFeatures || !document?.addEventListener)return false;
  let origin;try{const url=new URL(endpoint);if(url.protocol!=='https:')return false;origin=url.origin;}catch{return false;}
  const key='beskar_chatgpt_privacy_v1';let busy=false;
  let debug=false;
  try{const values=new URLSearchParams(document.location?.search??'').getAll('beskar_measurement_debug');debug=values.length===1 && values[0]==='1';}catch{}
  const diagnostic=entry=>{if(debug)try{console.info('[BESKAR measurement] '+JSON.stringify({component:'theme_observer',...entry}));}catch{}};
  // Read the existing key only; diagnostics never write storage or invent state.
  if(debug)Promise.resolve().then(()=>storage.getItem(key)).then(
    ()=>diagnostic({kind:'storage_access',accessible:true}),
    ()=>diagnostic({kind:'storage_access',accessible:false}));
  const revoke=async()=>{
    if(busy)return;busy=true;
    try{
      const value=JSON.parse(await storage.getItem(key)||'null');
      if(!value?.sessionId || !/^[a-f0-9]{64}$/.test(value.sessionToken??''))return;
      const minimal={sessionId:value.sessionId,sessionToken:value.sessionToken,revocationOnly:true};
      await storage.setItem(key,JSON.stringify(minimal));
      const response=await fetcher(`${origin}/consent/revoke`,{method:'POST',credentials:'omit',keepalive:true,
        headers:{'content-type':'application/json',Authorization:`Bearer ${value.sessionToken}`},body:JSON.stringify({sessionId:value.sessionId})});
      if(response.ok)await storage.removeItem(key);
    }catch{}finally{busy=false;}
  };
  const check=kind=>{
    const api=Shopify.customerPrivacy;if(!api)return;
    if(debug){
      try{const keys=['marketingAllowed','analyticsProcessingAllowed','saleOfDataAllowed'];
        const privacy=Object.fromEntries(keys.map(key=>{const value=api[key]();return [key,{type:typeof value,value:typeof value==='boolean'?value:null}];}));
        diagnostic({kind,privacy});
      }catch{} // Observe only; the original permission check below stays intact.
    }
    // Storefront API functions have different names from pixel event fields.
    if(api.analyticsProcessingAllowed()!==true || api.marketingAllowed()!==true || api.saleOfDataAllowed()!==true)void revoke();
  };
  document.addEventListener('visitorConsentCollected',()=>check('visitorConsentCollected'));
  Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],error=>{if(!error)check('init');});
  return true;
}

installConsentWithdrawalObserver({Shopify:window.Shopify,document:document,storage:window.localStorage,endpoint:"https://beskar-paid-measurement.silvercocoa1024.chatgpt.site",enabled:true});
})();
